module.exports = __webpack_public_path__ + "img/ico_fcu_1.1d9e70d5.png";